import { render, staticRenderFns } from "./LpuCardsFiltersNavItem.vue?vue&type=template&id=59e60187&scoped=true&"
import script from "./LpuCardsFiltersNavItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuCardsFiltersNavItem.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LpuCardsFiltersNavItem.vue?vue&type=style&index=0&id=59e60187&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e60187",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59e60187')) {
      api.createRecord('59e60187', component.options)
    } else {
      api.reload('59e60187', component.options)
    }
    module.hot.accept("./LpuCardsFiltersNavItem.vue?vue&type=template&id=59e60187&scoped=true&", function () {
      api.rerender('59e60187', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/LpuCardsFiltersNavItem.vue"
export default component.exports